'use client';

import { c as _c } from "react/compiler-runtime";
import { CalendarWrapper } from '@algoacademy/design-system/web/forms/Calendar';
type BookingsCalendarProps = {
  selectedDay: Date;
  setSelectedDay: (day: Date) => void;
  onMonthChange: (day: Date) => void;
  bookingDays: Set<string>;
};
export function BookingsCalendar(t0) {
  const $ = _c(7);
  const {
    selectedDay,
    setSelectedDay,
    onMonthChange,
    bookingDays
  } = t0;
  let t1;
  if ($[0] !== setSelectedDay) {
    t1 = day => day && setSelectedDay(day);
    $[0] = setSelectedDay;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bookingDays || $[3] !== onMonthChange || $[4] !== selectedDay || $[5] !== t1) {
    t2 = <CalendarWrapper mode="single" selected={selectedDay} onSelect={t1} onMonthChange={onMonthChange} availableDays={bookingDays} disableUnavailableDays={true} required={true} allowPast={true} />;
    $[2] = bookingDays;
    $[3] = onMonthChange;
    $[4] = selectedDay;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}